import styled from 'styled-components';

export const StyledForgotPassword = styled.div`
  margin: 10px 0 10px;
  text-align: right;
  font-size: ${props => props.theme.fontSizes.small};
`
